import { ArrowLeftIcon, SparklesIcon } from 'lucide-react'

import { Button, Card, CardContent, CardHeading } from '@/components/ui'
import type { Project } from '@/modules/projects'
import { CaseSummary } from '../CaseSummary'
import { OverallInstructions } from './OverallInstructions'
import { ReportPreview } from './ReportPreview'
import { Sections } from './Sections'

interface CustomizeReportProps {
  project: Project
  isSubmitting: boolean
  onGenerate: () => void
  onCancel: () => void
}

// Editing on the left (sections + narrative), a live preview and the generate
// CTA pinned in the right sidebar.
export const CustomizeReport = ({
  project,
  isSubmitting,
  onGenerate,
  onCancel,
}: CustomizeReportProps) => (
  <div className="space-y-4">
    <button
      type="button"
      onClick={onCancel}
      className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-foreground cursor-pointer transition-colors"
    >
      <ArrowLeftIcon className="size-4" />
      Back to quick generate
    </button>

    <div className="grid gap-6 2xl:grid-cols-[minmax(0,1fr)_460px]">
      <Card className="min-w-0">
        <CardHeading
          title="Generate custom report"
          description="We've included the most relevant sections for your case type. Drag sections to add, remove, or reorder them to fit your needs."
        />

        <CardContent className="space-y-8">
          <Sections />
          <OverallInstructions />
        </CardContent>
      </Card>

      <Card className="h-fit lg:sticky lg:top-6 lg:max-h-[calc(100vh-3rem)] lg:overflow-y-auto">
        <CardContent className="space-y-6 p-6">
          <CaseSummary />

          <ReportPreview />

          <Button
            className="w-full"
            onClick={onGenerate}
            isLoading={isSubmitting}
          >
            <SparklesIcon className="h-4 w-4" />
            Generate report
          </Button>
        </CardContent>
      </Card>
    </div>
  </div>
)
